import { pageRoutes } from "../../../../routes";
import EntitiesListPage from "../../../entityFields/grid/EntitiesListPage";

const PortfolioCompaniesPage = () => {
  return (
    <EntitiesListPage
      objectType="PortfolioCompany"
      objectDetailsPathPattern={`/:clientCode/${pageRoutes.portfolio}/${pageRoutes.portfolioCompanies}/:id`}
      objectsTitle="Portfolio Companies"
      showLogos
    />
  );
};

export default PortfolioCompaniesPage;
